import { NUTRIENTS } from '../constants/nutrients.constants';
import { HARVEST_PHASES } from '../constants/phases.constants';
import type { FixedParcelEntry, ParcelData } from '../types/parcelling.types';

export const createEmptyParcelData = (): ParcelData => ({
	phase: new Array(12).fill('') as ParcelData['phase'],
	N: new Array(12).fill(Number.NaN),
	P: new Array(12).fill(Number.NaN),
	K: new Array(12).fill(Number.NaN),
	Ca: new Array(12).fill(Number.NaN),
	Mg: new Array(12).fill(Number.NaN),
	S: new Array(12).fill(Number.NaN),
	B: new Array(12).fill(Number.NaN),
	Cu: new Array(12).fill(Number.NaN),
	Fe: new Array(12).fill(Number.NaN),
	Mn: new Array(12).fill(Number.NaN),
	Zn: new Array(12).fill(Number.NaN),
});

export const toFixedParcelPayload = (parcels: ParcelData): FixedParcelEntry[] =>
	Array.from({ length: 12 }, (_, index) => {
		const entry = { month: index + 1, phase: parcels.phase[index] } as FixedParcelEntry;
		NUTRIENTS.forEach((nutrient) => {
			entry[nutrient] = parcels[nutrient][index];
		});
		return entry;
	});

export const fromFixedParcelPayload = (fixedParcel?: FixedParcelEntry[]): ParcelData => {
	if (fixedParcel?.length !== 12) return createEmptyParcelData();

	const byMonth = [...fixedParcel].sort((a, b) => a.month - b.month);
	const parcels = createEmptyParcelData();

	byMonth.forEach((entry, index) => {
		parcels.phase[index] = HARVEST_PHASES.includes(entry.phase)
			? entry.phase
			: ('' as ParcelData['phase'][number]);
		NUTRIENTS.forEach((nutrient) => {
			parcels[nutrient][index] = entry[nutrient];
		});
	});

	return parcels;
};
